var amdi18n={"__root":{"eid_client_added":"eID client added","eid_client_detected":"eID client detected","eid_client_not_detected":"eID client not detected","activation_succeeded":"Activation succeeded","activation_failed":"Activation failed","eid_client_detection_started":"eID client detection started","eid_client_detection_cycle_finished":"eID client detection cycle finished","eid_client_detection_stopped":"eID client detection stopped","eid_client_filtered":"eID client filtered","activating_eid_client":"Activating eID client"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/service/nls/EidClientManager_strings.js
// module id = 290
// module chunks = 4